const QueryKey = {
    comDashboard: 'comDashboard',
    comUserProfile: 'comUserProfile',
    comList: 'comList',
    potList: 'potList',
    amctSinglePo: 'amctSinglePo',
    singleCom: 'singleCom',
    amctSinglePoProd: 'amctSinglePoProd',

}

export default QueryKey;